var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "commonSelect" },
    [
      _vm.$isFlag
        ? _c("van-field", {
            staticStyle: { "border-radius": "0" },
            attrs: {
              readonly: "",
              clickable: "",
              name: "picker",
              label: _vm.selectionInfo.selectName,
              value: _vm.gameName,
              placeholder: "点击选择"
            },
            on: {
              click: function($event) {
                _vm.showPicker = true
              }
            }
          })
        : _c(
            "div",
            { staticClass: "selectWebClass" },
            [
              _c("p", [_vm._v(_vm._s(_vm.selectionInfo.selectName))]),
              _c(
                "el-select",
                {
                  attrs: { clearable: "", placeholder: "请选择" },
                  on: { change: _vm.onConfirm },
                  model: {
                    value: _vm.gameVal,
                    callback: function($$v) {
                      _vm.gameVal = $$v
                    },
                    expression: "gameVal"
                  }
                },
                _vm._l(_vm.selectionInfo.columns, function(item, i) {
                  return _c("el-option", {
                    key: item[_vm.selectionInfo.val] + i,
                    attrs: {
                      label: item[_vm.selectionInfo.label],
                      value: item[_vm.selectionInfo.val]
                    }
                  })
                }),
                1
              )
            ],
            1
          ),
      _c(
        "van-popup",
        {
          attrs: { position: "bottom" },
          model: {
            value: _vm.showPicker,
            callback: function($$v) {
              _vm.showPicker = $$v
            },
            expression: "showPicker"
          }
        },
        [
          _c("van-picker", {
            attrs: { "show-toolbar": "", columns: _vm.selectionInfo.columns },
            on: {
              confirm: _vm.onConfirm,
              cancel: function($event) {
                _vm.showPicker = false
              }
            },
            scopedSlots: _vm._u([
              {
                key: "option",
                fn: function(option) {
                  return [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "flex-direction": "column",
                          "align-items": "center"
                        }
                      },
                      [
                        _c("div", [
                          _vm._v(_vm._s(option[_vm.selectionInfo.label]))
                        ])
                      ]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }